<template>
  <div>
    <label>Operadoras</label>
      <v-autocomplete
        v-model="operadoraId"
        :items="operadoras"
        :search-input.sync="searchInput" 
        item-value="id"
        item-text="oper_nome"
        label="Selecione"
        chips
        outlined
        flat
        solo
        dense
        filled
        :rules="formRules.required"
      >
        <template v-slot:selection="data">
          <v-chip small label class="ma-1" style="max-width:90%">
            {{ data.item.oper_nome }}
          </v-chip>
        </template>
      </v-autocomplete>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    value: Number,
    prestadorId: Number
  },
  model: {
    props: 'value',
    event: 'change'
  },
  data: function () {
    return {
      operadoras: [],
      searchInput: ''
    }
  },
  computed: {
    operadoraId: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('change', val)
      }
    },
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules: state => state.formRules
    })
  },
  methods: {
    ...mapActions('permissions', ['getOperadoras'])
  },
  watch: {
    prestadorId: {
      immediate: true,
      handler: async function (newVal) {
        if (newVal) {
          this.operadoras = await this.getOperadoras({
            modulo_operadora: 'recebiveis',
            prestador_ids: [newVal]
          })
        }
      }
    }
  }
}
</script>
